import React, { useState, useEffect, useRef } from 'react';
import CommonBtn from '../../containers/LeadProfile/CommonBtn/CommonBtn';
import person_icon from '../../images/icons/AuditTrailIcons/person_icon.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Comment.module.css';
import { faTrashAlt, faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
import CircularProgress from '@material-ui/core/CircularProgress';

import { DateFormat } from '../../components/Table/RMColumnData';

const { more_option, threeDot } = styles;

function CommonTextArea({
  onlyWrite,
  each,
  index,
  deleteComment,
  commentId,
  textVal,
  setTextVal,
  onClickCTA
}) {
  const [showDeleteBtn, setShowDeleteBtn] = useState(false);

  return (
    <React.Fragment>
      {onlyWrite && (
        <>
          <div className="flex">
            <img src={person_icon} alt="" className="self-start" />

            <textarea
              className="hover:shadow w-full h-22 mr-3 p-2 bg-grey-2230 border border-navy-400 rounded"
              cols="30"
              rows="10"
              value={textVal}
              onChange={e => setTextVal(e.target.value)}
            ></textarea>
          </div>
          <CommonBtn
            value="Post"
            onClick={() => {
              onClickCTA();
            }}
            stylesBtn={{
              backgroundColor: '#00ACB8',
              color: 'white',
              float: 'right',
              marginTop: '10px',
              padding: '5px 20px'
            }}
          />
        </>
      )}

      {/* ////view mode */}

      {!onlyWrite && (
        <div className="viewMode " onClick={() => setShowDeleteBtn(false)}>
          <div className="canEditMode">
            <div className="flex justify-between">
              <div className="flex text-white">
                <img
                  src={person_icon}
                  alt="icon"
                  className="pr-2 relative self-start"
                  style={{
                    top: '6px'
                  }}
                />
                <p className="pr-6 pt-2 text-sm font-roboto text-black-400">
                  {each?.comment || ''}
                </p>
              </div>

              <div className="relative">
                <div
                  className={`${threeDot} text-2xl font-medium relative h-0 cursor-pointer`}
                  onClick={e => {
                    e.stopPropagation();
                    setShowDeleteBtn(!showDeleteBtn);
                  }}
                >
                  <FontAwesomeIcon icon={faEllipsisH} />
                </div>

                {showDeleteBtn && (
                  <div
                    onClick={() => {
                      deleteComment({
                        index,
                        commentId
                      });
                    }}
                    className={`flex flex-col shadow rounded bg-white text-black-400 text-xs mt-1 ${more_option}`}
                  >
                    <div className="cursor-pointer hover:font-medium hover:text-red-300">
                      <FontAwesomeIcon icon={faTrashAlt} />
                      <span className="inline-block pl-2">Delete</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="flex pt-2 text-grey-2221 text-xs pl-7 mb-3">
              <p className="pr-5">
                {(each?.userName?.firstName || '') +
                  ' ' +
                  (each?.userName?.middleName || '') +
                  ' ' +
                  (each?.userName?.lastName || '')}
              </p>
              <p>{DateFormat(each?.createdOn)} </p>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default CommonTextArea;
